import { render, staticRenderFns } from "./PolicyStatusSelect.vue?vue&type=template&id=c29dea4a&scoped=true"
import script from "./PolicyStatusSelect.vue?vue&type=script&lang=ts"
export * from "./PolicyStatusSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29dea4a",
  null
  
)

export default component.exports